import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '..';
import * as fromAircraftEvent from './aircraft-event.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');

// feature slice - aircraftEvent
const getAircraftEventSubState = createSelector(getSharedAuditState, state => state.aircraftEvent);

// aircraftEvent slice selectors
const getAircraftEventSkeletonsState = createSelector(
  getAircraftEventSubState,
  state => state.aircraftEventSkeletons
);
const getAircraftEventAuditState = createSelector(
  getAircraftEventSubState,
  state => state.aircraftEventAudit
);
const getAircraftEventBusinessPersonAuditState = createSelector(
  getAircraftEventSubState,
  state => state.aircraftEventBusinessPersonAudit
);
const getScheduledEventAuditState = createSelector(
  getAircraftEventSubState,
  state => state.scheduledEventAudit
);
const getAircraftEventTypesState = createSelector(
  getAircraftEventSubState,
  state => state.aircraftEventTypes
);
const getFlightBusinessPersonTypesState = createSelector(
  getAircraftEventSubState,
  state => state.flightBusinessPersonTypes
);

// aircraftEvent skeletons
export const getAircraftEventSkeletonsLoaded = createSelector(
  getAircraftEventSkeletonsState,
  state => state.loaded
);
export const getAircraftEventSkeletonsLoading = createSelector(
  getAircraftEventSkeletonsState,
  state => state.loading
);
// const getAircraftEventSkeletonsError = createSelector(
//   getAircraftEventSkeletonsState,
//   state => state.error
// );
// const getAircraftEventSkeletons = createSelector(
//   getAircraftEventSkeletonsState,
//   getAircraftEventSkeletonsLoaded,
//   (state, isLoaded) => {
//     return isLoaded ? state.entities : null;
//   }
// );
export const getAircraftEventAuditSkeletons = createSelector(
  getAircraftEventSkeletonsState,
  fromAircraftEvent.aircraftEventSkeletonSelectors.selectAll
);

// aircraftEvent audits
export const getAircraftEventAuditLoaded = createSelector(
  getAircraftEventAuditState,
  state => state.loaded
);
export const getAircraftEventAuditLoading = createSelector(
  getAircraftEventAuditState,
  state => state.loading
);
export const getAircraftEventAudits = createSelector(
  getAircraftEventAuditState,
  fromAircraftEvent.aircraftEventAuditSelectors.selectAll
);

// aircraftEvent businessPerson audits
export const getAircraftEventBusinessPersonAuditLoaded = createSelector(
  getAircraftEventBusinessPersonAuditState,
  state => state.loaded
);
export const getAircraftEventBusinessPersonAuditLoading = createSelector(
  getAircraftEventBusinessPersonAuditState,
  state => state.loading
);
export const getAircraftEventBusinessPersonAudits = createSelector(
  getAircraftEventBusinessPersonAuditState,
  fromAircraftEvent.aircraftEventBusinessPersonAuditSelectors.selectAll
);

// aircraftEvent scheduledEvent audits
export const getScheduledEventAuditLoaded = createSelector(
  getScheduledEventAuditState,
  state => state.loaded
);
export const getScheduledEventAuditLoading = createSelector(
  getScheduledEventAuditState,
  state => state.loading
);
export const getScheduledEventAudits = createSelector(
  getScheduledEventAuditState,
  fromAircraftEvent.scheduledEventAuditSelectors.selectAll
);

// aircraftEvent types
export const getAircraftEventTypesLoaded = createSelector(
  getAircraftEventTypesState,
  state => state.loaded
);
export const getAircraftEventTypesLoading = createSelector(
  getAircraftEventTypesState,
  state => state.loading
);
export const getAircraftEventTypes = createSelector(
  getAircraftEventTypesState,
  fromAircraftEvent.aircraftEventTypeSelectors.selectAll
);

// flightBusinessPerson types
export const getFlightBusinessPersonTypesLoaded = createSelector(
  getFlightBusinessPersonTypesState,
  state => state.loaded
);
export const getFlightBusinessPersonTypesLoading = createSelector(
  getFlightBusinessPersonTypesState,
  state => state.loading
);
export const getFlightBusinessPersonTypes = createSelector(
  getFlightBusinessPersonTypesState,
  fromAircraftEvent.flightBusinessPersonTypeSelectors.selectAll
);
